import { Controller } from "@hotwired/stimulus";

// Single-select template picker for the "From template gallery" drawer.
// Cards are clickable; selecting one highlights its border, reveals the
// inline checkmark, and writes its id into a hidden field so the footer
// "Start with template" button can submit the form. The submit button
// stays disabled until a selection is made.
//
// Markup contract:
//   data-controller="template-gallery"
//   data-template-gallery-target="hiddenInput"   (hidden <input> named template_id)
//   data-template-gallery-target="submitButton"  (the CTA)
//   data-template-gallery-target="card"          (each clickable card)
//     data-template-gallery-template-id-param="<id>"
//   data-template-gallery-target="checkmark"     (the per-card check icon,
//                                                 starts with `hidden` class)
export default class extends Controller<HTMLElement> {
  static targets = ["card", "checkmark", "hiddenInput", "submitButton"];

  declare readonly cardTargets: HTMLElement[];
  declare readonly checkmarkTargets: HTMLElement[];
  declare readonly hiddenInputTarget: HTMLInputElement;
  declare readonly submitButtonTarget: HTMLButtonElement;
  declare readonly hasSubmitButtonTarget: boolean;

  select(event: Event) {
    const card = event.currentTarget as HTMLElement;
    const templateId = card.dataset.templateGalleryTemplateIdParam;
    if (!templateId) return;

    this.cardTargets.forEach((c) => {
      const isSelected = c === card;
      c.classList.toggle("border-primary", isSelected);
      c.classList.toggle("border-2", isSelected);
      c.classList.toggle("border", !isSelected);
      c.setAttribute("aria-pressed", String(isSelected));
    });

    this.checkmarkTargets.forEach((mark) => {
      const owningCard = mark.closest('[data-template-gallery-target="card"]');
      mark.classList.toggle("hidden", owningCard !== card);
    });

    this.hiddenInputTarget.value = templateId;
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false;
    }
  }
}
